import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Currency from '@prisjakt/ui-currency';
import { PriceLabelStyleType } from 'src/components/offer/price/types';

import {
  PriceDisplay,
  PriceDisplayEnum,
} from 'src/components/price-list/types';

import * as S from './styles';

type OwnProps = {
  inclShipping?: number | null;
  exclShipping: number;
  toneDown: boolean;
  priceDisplay: PriceDisplay;
  compact?: boolean;
};

const ShippingLabel = ({
  inclShipping,
  exclShipping,
  toneDown = false,
  priceDisplay,
  compact = false,
  ...rest
}: OwnProps) => {
  const { t } = useContext(AppContext);
  let shippingValue: string;
  if (!inclShipping) {
    shippingValue = t('product', 'price.unknown-shipping');
  } else if (inclShipping === exclShipping) {
    shippingValue = t('product', 'price.free-shipping');
  } else {
    shippingValue =
      priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING
        ? t('product', 'price.excluding-shipping', {
            price: <Currency key="currency" price={exclShipping} />,
          })
        : t('product', 'price.including-shipping', {
            price: <Currency key="currency" price={inclShipping} />,
          });
  }

  return (
    <S.ShippingLabel
      bold={false}
      value={shippingValue}
      styling={
        toneDown ? PriceLabelStyleType.LIGHTEN : PriceLabelStyleType.SECONDARY
      }
      compact={compact}
      {...rest}
    />
  );
};

export default ShippingLabel;
